import Grid from '@mui/material/Unstable_Grid2'
import Box from '@mui/material/Box'
import { PasswordInput, TextInput } from '../components'

const LoginTemplateTfaHelpPages = ({
    userName = '',
    password = '',
    tfaPasscode = '',
    userNameLabel = 'User ID',
    onUserNameChange,
    onPasswordChange,
    onTfaPasscodeChange,
    tfaPasscodeLabel = '2FA Passcode',
    showTfaPasscode = false,
    userNameError = '',
    userNameDisabled = false,
    passwordError = '',
    tfaPasscodeError = '',
    autoFocusUserName = true,
}) => {
    return (
        <Box id="loginTemplateTfaHelpPages" data-automation-id="login_template_tfa_help_pages">
            <Grid container>
                <Grid xs={12}>
                    <TextInput
                        id="tfa_username_input"
                        label={userNameLabel}
                        name="user"
                        dataAutomationId="tfa_username_input"
                        required
                        autoComplete="username"
                        disabled={userNameDisabled}
                        autoFocus={autoFocusUserName && !userNameDisabled}
                        error={!!userNameError}
                        helperText={userNameError}
                        value={userName}
                        onChange={onUserNameChange}
                    />
                </Grid>
                <Grid xs={12}>
                    <PasswordInput
                        id="tfa_password_input"
                        label="Password"
                        autoComplete="off"
                        name="password"
                        dataAutomationId="tfa_password_input"
                        required
                        error={!!passwordError}
                        helperText={passwordError}
                        value={password}
                        onChange={onPasswordChange}
                    />
                </Grid>
                {showTfaPasscode &&
                    <Grid xs={12}>
                        <TextInput
                            label={tfaPasscodeLabel}
                            name="otpCode"
                            id="otpcode_input"
                            dataAutomationId="otpcode_input"
                            autoComplete="one-time-code"
                            required
                            numericOnly maxLength={6}
                            error={!!tfaPasscodeError}
                            helperText={tfaPasscodeError}
                            value={tfaPasscode}
                            onChange={onTfaPasscodeChange}
                        />
                    </Grid>
                }
            </Grid>
        </Box>
    );
};

export default LoginTemplateTfaHelpPages;
